import React from "react";
import "./Emoji.scss";

// Module-level map: name → emoji character + SVG filename.
// Kept here (not inside the component) so babel-plugin-react-compiler never
// touches the emoji string literals during memoization code generation.
const EMOJI_MAP = {
  bolt:        "⚡️",
  search:      "🔍",
  ghost:       "👻",
  eyes:        "👀",
  headphones:  "🎧",
  coffee:      "☕️",
  peace:       "✌🏻",
  wave:        "👋🏻",
  chat:        "💬",
  game:        "🎮",
  pencil:      "✏️",
  floppy:      "💾️",
  hourglass:   "⏳",
  alarm:       "⏰",
  timer:       "⏱",
  cross:       "❌",
  check:       "✅",
  rocket:      "🚀",
  muscle:      "💪🏻",
  "point-left": "👈🏻",
  "thumbs-up":  "👍🏻",
  write:       "✍🏻",
  "thumbs-down": "👎🏻",
};

function Emoji({ icon }) {
  const emoji = EMOJI_MAP[icon];
  if (!emoji) return icon;
  return (
    <img
      src={`/workspace/emoji/${emoji}.svg`}
      role="presentation"
      className="emoji"
      alt=""
    />
  );
}

export default Emoji;
